var exports = {
  "Tc": "ChannelUserTag.module__tag___cW1ONX",
  "Dm": "ChannelUserTag.module__tagSm___cW1ONX",
  "ST": "ChannelUserTag.module__tagLg___cW1ONX",
  "Qq": "ChannelUserTag.module__text___cW1ONX",
  "WV": "ChannelUserTag.module__textSm___cW1ONX",
  "j": "ChannelUserTag.module__textLg___cW1ONX",
};

module.exports = exports;
